import Api from "../../../../shared/api/api";
let mutationRevision = 0;
export const outreachRevision = () => mutationRevision;
export const outreach = async (path, data = {}, method = "get") => {
  const result = await Api.request(`api/outreach/${path}`, data, method);
  if (method !== "get" && !/discovery\/search|email-preview|templates\/render|import\/preview/.test(path)) mutationRevision += 1;
  return result;
};
export function download(text, filename, type = "text/plain") {
  const url = URL.createObjectURL(new Blob([text], {
    type
  }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function utc(value) {
  return value ? new Date(value).toISOString() : null;
}
export function localDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}
export const label = value => value === "submissions_closed" ? "Submissions Closed" : String(value || "").replace(/_/g, " ");
export function reportCSV(report) {
  const rows = [["Metric", "Group", "Value"]];
  for (const [key, value] of Object.entries(report)) {
    if (Array.isArray(value)) value.forEach(row => rows.push([key, Object.entries(row).filter(([k]) => k !== "total").map(([k, v]) => `${k}: ${v}`).join("; "), row.total ?? ""]));else if (value && typeof value === "object") Object.entries(value).forEach(([field, v]) => rows.push([key, field, v ?? "Unknown"]));else rows.push([key, "", value ?? "Unknown"]);
  }
  const cell = value => {
    let text = String(value);
    if (/^[\s\u0000-\u001f]*[=+@-]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  };
  return rows.map(row => row.map(cell).join(",")).join("\r\n");
}
